import React from 'react';
import {
  Typography,
  Wrap,
  Select,
  Button,
  Input,
  BackButton,
  Loader,
} from '../../components/index';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useParams, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { scrollToTop, useResponsivity } from '../../helpers/helpers';
import Washroom from './Washroom';
import Kitchen from './Kitchen/Kitchen';
import { formatWashroomAnswers } from '../../helpers/formatWashroomAnswers';
import { formatKitchenAnswers } from '../../helpers/formatKitchenAnswers';
import Styled from './AddRoom.style';
interface AddRoomProps {
  questions: any;
  getQuestions: Function;
  addRoom: Function;
  clearAnswerKey: Function;
  room: any;
  listLocation: any;
  resetAddRoom: Function;
}

const AddRoom: React.FC<AddRoomProps> = (props) => {
  const {
    questions,
    room,
    getQuestions,
    addRoom,
    clearAnswerKey,
    listLocation,
    resetAddRoom,
  } = props;
  const { loading, error } = props.questions.status;
  const locationData = _.get(listLocation, 'data.data');
  const { locationId } = useParams();

  const navigate = useNavigate();
  const addRoomDone = _.get(room, 'addRoom.status.done');
  const addRoomLoading = _.get(room, 'addRoom.status.loading');
  const findElement = _.find(locationData, function (o) {
    return o.id == locationId;
  });
  const getRooms = _.get(findElement, 'rooms');
  const roomLength = _.get(getRooms, 'length');
  const isMobile = useResponsivity();

  const roomType = [
    { label: 'Washroom', value: 'washroom' },
    { label: 'Kitchen', value: 'kitchen' },
  ];
  const [selectRoom, setRoom] = React.useState('');
  const [roomAnswers, setRoomAnswers] = React.useState({});
  React.useEffect(() => {
    resetAddRoom();

    return () => {
      resetAddRoom();
    };
  }, [resetAddRoom]);
  React.useEffect(() => {
    if (!selectRoom || !roomAnswers) return;
  }, [roomAnswers, selectRoom]);

  const handleRoomType = (e) => {
    const room = e.target.value;

    setRoom(room);
    clearAnswerKey();
    getQuestions(room);

    setRoomAnswers({});
  };
  React.useEffect(() => {
    if (selectRoom) {
      scrollToTop();
    }
  }, [selectRoom]);

  const renderMessage = () => {
    return (
      <Col md={12} sm={12} xs={12}>
        <Typography
          size="p"
          style={{ textAlign: 'center', marginTop: '32px', fontWeight: 600 }}
          text="You have not selected any room. Please select a room in order to see the questions."
        />
      </Col>
    );
  };
  if (roomLength >= 10) {
    return (
      <Wrap>
        <Styled.Box>
          <Typography
            size="p"
            style={{ textAlign: 'center', fontWeight: 600 }}
            text="You have added the maximum number of rooms. Please delete some."
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '32px',
              flexDirection: isMobile ? 'column' : 'row',
            }}
          >
            <Button
              style={{
                marginRight: '16px',
                marginBottom: isMobile ? '16px' : '0px',
              }}
              onClick={() => navigate('/portal')}
            >
              Home
            </Button>
            <Button
              onClick={() => navigate(`/locations/${locationId}`)}
              style={{ marginRight: '16px' }}
            >
              Edit rooms
            </Button>
          </div>
        </Styled.Box>
      </Wrap>
    );
  }
  const AddRoomSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
  });
  const renderForm = () => {
    return (
      <Formik
        initialValues={{
          name: '',
        }}
        validationSchema={AddRoomSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);

          const formattedData =
            selectRoom === 'washroom'
              ? formatWashroomAnswers(roomAnswers)
              : formatKitchenAnswers(roomAnswers);

          addRoom(locationId, selectRoom, values.name, formattedData);

          scrollToTop();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => {
          return (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Row>
                <Col xs={12} sm={12} md={6}>
                  <Select
                    onChange={handleRoomType}
                    value={selectRoom}
                    options={roomType}
                    name="room"
                    placeholder="Choose the type of your room"
                  />
                </Col>
                <Col xs={12} sm={12} md={6}>
                  <Input
                    id="name"
                    name="name"
                    value={values.name}
                    type="text"
                    placeholder="Name of room​"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.name && touched.name ? errors.name : undefined
                    }
                  />
                </Col>

                {loading && <Loader />}
                {error && (
                  <Typography
                    size="p"
                    style={{
                      textAlign: 'center',
                      marginTop: '32px',
                      fontWeight: 600,
                    }}
                    text="There was a problem with"
                  />
                )}

                {questions.data && selectRoom !== '' && !loading ? (
                  <Col xs={12} md={12} sm={12}>
                    {selectRoom === 'washroom' ? (
                      <Washroom onChange={setRoomAnswers} />
                    ) : (
                      <Kitchen onChange={setRoomAnswers} />
                    )}
                  </Col>
                ) : (
                  renderMessage()
                )}
                {selectRoom === '' || loading ? null : (
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      flexDirection: isMobile ? 'column' : 'row',
                    }}
                  >
                    <Button
                      disabled={isSubmitting}
                      isLoading={addRoomLoading}
                      type="submit"
                    >
                      Create room
                    </Button>
                  </Col>
                )}
              </Row>
            </form>
          );
        }}
      </Formik>
    );
  };

  return (
    <Wrap>
      <Row>
        <Col md={12} sm={12} xs={12}>
          <Typography
            size="1"
            text="Add room"
            style={{ marginBottom: '32px' }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} sm={12} xs={12} style={{ marginBottom: '32px' }}>
          <BackButton />
        </Col>
      </Row>
      <Row>
        {addRoomDone ? (
          <Col
            md={12}
            sm={12}
            xs={12}
            style={{ background: 'white', border: '1px solid #e6e6e6' }}
          >
            <Typography
              size="4"
              style={{
                textAlign: 'center',
                marginTop: '32px',
                fontWeight: 600,
              }}
              text="Success!"
            />
            <Typography
              size="p"
              style={{
                textAlign: 'center',
                marginTop: '32px',
                fontWeight: 400,
              }}
              text="New room created"
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '32px',
                flexDirection: isMobile ? 'column' : 'row',
                marginBottom: '32px',
              }}
            >
              <Button
                style={{
                  marginRight: '16px',
                  marginBottom: isMobile ? '16px' : '0px',
                }}
                onClick={() => {
                  navigate('/portal');
                  window.location.reload();
                }}
              >
                Home
              </Button>
              <Button
                onClick={() => {
                  clearAnswerKey();
                  setRoom('');
                  window.location.reload();
                }}
                style={{ marginRight: '16px' }}
              >
                Create new room
              </Button>
            </div>
          </Col>
        ) : (
          <Col md={12} sm={12} xs={12}>
            {renderForm()}
          </Col>
        )}
      </Row>
    </Wrap>
  );
};

export default AddRoom;
